import { render, staticRenderFns } from "./form-file-import.vue?vue&type=template&id=70d82d6d&scoped=true"
import script from "./form-file-import.vue?vue&type=script&lang=ts"
export * from "./form-file-import.vue?vue&type=script&lang=ts"
import style0 from "./form-file-import.vue?vue&type=style&index=0&id=70d82d6d&prod&lang=css&scoped=true"
import style1 from "./form-file-import.vue?vue&type=style&index=1&id=70d82d6d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d82d6d",
  null
  
)

export default component.exports